import React from "react";
import { SITE } from "../../data/content";

export default function ContactHoursBox() {
  return (
    <div className="bg-white border border-[#d6dcb6] p-5 text-sm space-y-3">
      <div>
        <p className="font-display text-[#7d8e54] text-lg">Contact Us:</p>
        <p>P: {SITE.phone}</p>
        <p>F: {SITE.fax}</p>
      </div>
      <div>
        <p className="font-display text-[#7d8e54] text-lg">Location:</p>
        <p>{SITE.address1}</p>
        <p>{SITE.address2}</p>
        <p>{SITE.address3}</p>
      </div>
      <div>
        <p className="font-display text-[#7d8e54] text-lg">Hours:</p>
        {SITE.hours.map((h) => (
          <p key={h.day}>
            {h.day} {h.time}
          </p>
        ))}
        <p className="italic mt-1">{SITE.hoursNote}</p>
      </div>
    </div>
  );
}
